<template>
  <section class="user-card">
    <div class="user-avatar">
      <img v-if="user?.picture" :src="user.picture" alt="User picture" />
      <v-icon v-else size="28" color="#4a5a60">mdi-account</v-icon>
    </div>

    <div class="user-text">
      <div class="user-eyebrow">Signed in as</div>
      <h2 class="user-name">{{ capitalizeFirst(user?.nickname) }}</h2>
      <p class="user-email">{{ user?.email }}</p>
      <span class="user-role-pill">{{ userTitle }}</span>
    </div>
  </section>
</template>

<script>
import { getUserTitleFromRoleName } from '@/utils/AuthRolesMap';

export default {
  name: "BasicUserInformationCard",
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      userTitle: 'User',
    };
  },
  mounted() {
    this.setUserTitle();
  },
  watch: {
    user() {
      this.setUserTitle();
    }
  },
  methods: {
    capitalizeFirst(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    setUserTitle() {
      if (!this.user) return;
      const roles = this.user[`${process.env.VUE_APP_AUTH0_AUDIENCE}/roles`] || [];
      this.userTitle = getUserTitleFromRoleName(roles[0]);
    }
  }
}
</script>

<style scoped>
.user-card {
  background: var(--duallo-card-gradient);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  padding: 16px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 14px;
}

.user-avatar {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  background: #1c272c;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.user-text {
  flex: 1 1 auto;
  min-width: 0;
}

.user-eyebrow {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8aa0aa;
  margin-bottom: 2px;
}

.user-name {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 2px;
  color: #ffffff;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-email {
  font-size: 0.8rem;
  color: #b0bec5;
  margin: 0 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-role-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(102, 199, 180, 0.12);
  border: 1px solid rgba(102, 199, 180, 0.25);
  color: var(--duallo-accent-muted);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
